$(document).on('turbo:load', function() {
  $("body").on("click", "[data-toggle] .disabled", function(){
    return false;
  });
});
